import { Space, Layout, Descriptions, Typography, message, Row, Col } from "antd";
import React, { useEffect, useState } from "react";
import { Stack, Box } from "@mui/material";
import { backendGetRequest, backendGetRequestWithCache } from "../../../helpers/callBackend";
import TitledSection from "../../../components/generic/titledSection";
import TransactionsHome from "./transactionHome";
import OuterBox from "../../../components/generic/arpariBoxes/OuterBox";

const { Text } = Typography;


const RuleDetails = (props) => {
    const ruleId = window.location.pathname.split("details/000")[1];
    const [ruleData, setRuleData] = useState({});
    const [transactionDataRaw, setTransactionDataRaw] = useState([]);
    const [transactionsLoading, setTransactionsLoading] = useState(true);
    const [transactionsPageCountExpected, setTransactionsPageCountExpected] = useState(1);
    const [transactionsPageCountReceived, setTransactionsPageCountReceived] = useState(0);
    const [totalRecordsTransactions, setTotalRecordsTransactions] = useState(-1);
    const [allRecordsReceivedTransactions, setAllRecordsReceivedTransactions] = useState(false);

    const [allAccounts, setAllAccounts] = useState({});

    const [customCategories, setCustomeCategories] = useState([]);
    const [loadingAllAccounts, setLoadingAllAccounts] = useState(true);

    const TXN_TAG = 2;

    const groupKeyToLabelMap = {
        EN: "Entity",
        BA: "Bank",
        AA: "All Accounts",
    }

    const updateTransactions = (newTransactions, originalTxnId) => {
        setTransactionDataRaw((prevState) => {
            const updatedCompleteTxns = prevState?.map((txn) => {
                if (txn.id === originalTxnId) {
                    return { ...txn, is_edited: true };
                }
                return txn;
            });
            return [...updatedCompleteTxns, ...newTransactions]
        })
    };

    const updateTransaction = (transactionId, updatedTransaction) => {
        setTransactionDataRaw((prevState) => {
            const updatedTransactions = prevState?.map((txn) => {
                if (txn.id === transactionId) {
                    return { ...txn, ...updatedTransaction };
                } else {
                    return txn;
                }
            });
            return updatedTransactions
        })
    }

    useEffect(() => {
        if (totalRecordsTransactions < 0) return;
        setAllRecordsReceivedTransactions(transactionDataRaw.length >= totalRecordsTransactions);
    }, [transactionDataRaw.length, transactionDataRaw]);

    useEffect(() => {
        setTransactionsLoading(true);

        backendGetRequest(`/api/${props.url}/rules/`, { params: { rule_id: ruleId } })
            .then((res) => {
                setRuleData(res?.data?.rules);
            });

        backendGetRequest(`/api/${props.url}/rule/transactions/`, { params: { rule_id: ruleId, page_index: 0 } })
            .then((res) => {
                setTransactionsPageCountExpected(res?.data?.total_pages);
                const requests = [];
                for (let i = 1; i <= res?.data?.total_pages; i++) {
                    const request = backendGetRequest(`/api/${props.url}/rule/transactions/`, { params: { rule_id: ruleId, page_index: i } })
                        .then((res) => {
                            setTransactionDataRaw(prevState => [...prevState, ...(res?.data?.transactions || [])]);
                            setTransactionsPageCountReceived(prevState => prevState + 1);
                        })
                        .catch(() => {
                            setTransactionsPageCountExpected(prevState => prevState - 1);
                        });
                    requests.push(request);
                }
                return Promise.all(requests);
            })
            .then(() => {
                setTransactionsLoading(false);
            });

        const processResponse = (data) => {
            if (!data) return;
            var bankAccounts = {};
            var i = 0, j = 0, k = 0, bankItem = {};
            for (i = 0; i < data.sub_portfolios.length; i++) {
                for (j = 0; j < data.sub_portfolios[i].bank_accounts.length; j++) {
                    bankItem = data.sub_portfolios[i].bank_accounts[j];
                    bankAccounts[bankItem['id']] = {
                        "bankName": bankItem['descriptor'],
                        "portfolioId": "",
                        "portfolioName": "",
                        "propertyId": "",
                        "propertyName": "",
                        "accountNumberLast4": bankItem['additional_data']['account_number_last_4_attribute'],
                    }
                }
                for (j = 0; j < data.sub_portfolios[i].properties.length; j++) {
                    for (k = 0; k < data.sub_portfolios[i]['properties'][j]['bank_accounts'].length; k++) {
                        bankItem = data.sub_portfolios[i]['properties'][j]['bank_accounts'][k];
                        bankAccounts[bankItem['id']] = {
                            "bankName": bankItem['descriptor'],
                            "portfolioId": "",
                            "portfolioName": "",
                            "propertyId": "",
                            "propertyName": "",
                            "accountNumberLast4": bankItem['additional_data']['account_number_last_4_attribute'],
                        }
                    }
                }
            }
            for (i = 0; i < data.unlinked_properties.length; i++) {
                for (j = 0; j < data.unlinked_properties[i].bank_accounts.length; j++) {
                    bankItem = data.unlinked_properties[i].bank_accounts[j];
                    bankAccounts[bankItem['id']] = {
                        "bankName": bankItem['descriptor'],
                        "portfolioId": "",
                        "portfolioName": "",
                        "propertyId": "",
                        "propertyName": "",
                        "accountNumberLast4": bankItem['additional_data']['account_number_last_4_attribute'],
                    }
                }
            }
            setAllAccounts(bankAccounts);
            setLoadingAllAccounts(false);
        }

        backendGetRequestWithCache("/api/portfolio/bank-accounts/", { params: { "sources": "UN;FI;PL;FT", "includeLast4": true } },
            (cachedResponse) => {
                if (loadingAllAccounts && cachedResponse.data) {
                    processResponse(cachedResponse.data);
                }
            },
            (nonCachedResponse) => {
                if (nonCachedResponse.data) {
                    processResponse(nonCachedResponse.data);
                }
            },
        );

        const fetchCustomCategories = async () => {
            try {
                const res = await backendGetRequest("/api/generic-tag", { params: { 'page_index': 0, group_type: TXN_TAG } });
                for (let i = 1; i <= res.data?.total_pages; i++) {
                    try {
                        const resPage = await backendGetRequest("/api/generic-tag", { params: { 'page_index': i, group_type: TXN_TAG } });
                        if (resPage.data) {
                            setCustomeCategories(prevData => [...prevData, ...resPage.data?.generic_tags]);
                        }
                    } catch (error) {
                        console.error(`Error fetching page ${i}:`, error);
                    }
                }
            } catch (error) {
                console.error('Error fetching custom categories:', error);
            }
        };

        fetchCustomCategories();
    }, []);

    const onAssign = (updatedTransactions) => {
        setTransactionDataRaw(prevState => {
            const updatedTransactionsMap = new Map(updatedTransactions.map(tx => [tx.id, tx]));
            return prevState.map(transaction =>
                updatedTransactionsMap.has(transaction.id)
                    ? updatedTransactionsMap.get(transaction.id)
                    : transaction
            );
        });
    }

    return (
        <OuterBox>
            <TitledSection
                title={ruleData.name}
            />
            <TitledSection
                title={`${props.label} Rule Details`}
                titleLevel={4}
                titleExtra={undefined}
                body={
                    <Descriptions column={1} bordered style={{ width: "100%" }}>
                        <Descriptions.Item
                            label={"Group"}
                            labelStyle={{ width: "15%" }}
                            contentStyle={{ width: "35%" }}>
                            <Col>
                                <Row style={{ fontSize: '1rem', color: '#888' }}>{groupKeyToLabelMap[ruleData.grouping_type]}</Row>
                                <Row>{ruleData.group_name}</Row>
                            </Col>
                        </Descriptions.Item>
                        <Descriptions.Item
                            label={"Description"}
                            labelStyle={{ width: "15%" }}
                            contentStyle={{ width: "35%" }}>
                            {ruleData.description}
                        </Descriptions.Item>
                        <Descriptions.Item
                            label={"Search Term"}
                            labelStyle={{ width: "15%" }}
                            contentStyle={{ width: "35%" }}>
                            {ruleData.search_term}
                        </Descriptions.Item>
                        {props.label === "General Ledger" && (
                            <Descriptions.Item
                                label={"G/L Tag"}
                                labelStyle={{ width: "15%" }}
                                contentStyle={{ width: "35%" }}>
                                {ruleData.gl_tag}
                            </Descriptions.Item>
                        )}
                        {props.label === "Custom Tag" && (
                            <Descriptions.Item
                                label={"Custom Tag"}
                                labelStyle={{ width: "15%" }}
                                contentStyle={{ width: "35%" }}>
                                {ruleData.generic_tag}
                            </Descriptions.Item>
                        )}
                        {false &&
                            <Descriptions.Item
                                label={"Automatic"}
                                labelStyle={{ width: "15%" }}
                                contentStyle={{ width: "35%" }}>
                                {ruleData.is_automated_rule !== undefined &&
                                    (ruleData.is_automated_rule ? "Yes" : "No")
                                }
                            </Descriptions.Item>}
                        <Descriptions.Item
                            label={"Date Created"}
                            labelStyle={{ width: "15%" }}
                            contentStyle={{ width: "35%" }}>
                            {ruleData.date_created?.split('T')[0]}
                        </Descriptions.Item>
                    </Descriptions>
                }
            />
            <TransactionsHome
                transactionData={transactionDataRaw}
                allAccounts={allAccounts}
                recordsCount={totalRecordsTransactions}
                customCategories={customCategories}
                loadingTable={transactionsLoading}
                updateTransactions={updateTransactions}
                updateTransaction={updateTransaction}
                transactionsLoading={transactionsLoading}
                ruleData={ruleData}
                onAssign={onAssign}
                generalLedgerRulePage={props.label === "General Ledger"}
                customTagRulePage={props.label === "Custom Tag"}
            />
        </OuterBox>
    );
};

export default RuleDetails;
